export const TWO_FA_REQUESTING       = 'TWO_FA_REQUESTING'
export const TWO_FA_REQUEST_SUCCESS       = 'TWO_FA_REQUEST_SUCCESS'
export const TWO_FA_POSTING       = 'TWO_FA_POSTING'
export const TWO_FA_SUCCESS  = 'TWO_FA_SUCCESS'
export const TWO_FA_ERROR    = 'TWO_FA_ERROR'  
export const TWO_FA_GET_API    = '/api/v1/user_mfa_session/new'  
export const TWO_FA_POST_API    = '/api/v1/users/mfasettings'  


// WEBPACK FOOTER //
// ./src/views/Pages/TwoFASetting/constants.js